import React, { ReactElement } from 'react'
import { FaTachometerAlt, FaUserEdit, FaInfoCircle, FaCubes, FaMapSigns, FaBuilding, FaLongArrowAltUp, FaDollarSign, FaFileAlt, FaMale, FaSitemap, FaTags, FaComments, FaTicketAlt, FaUpload, FaUserSecret, FaUserShield, FaEnvelope, FaMobileAlt, FaShoppingCart, FaServer } from "react-icons/fa";
import language from "../../resources/languages/fa_IR";

// Interfaces
import { Route } from "../../interfaces/layouts/dashboard";

const { Layouts: { Dashboard: { Route: RouteLanguage } } } = language

export const getRoutes = (user: any) => {

  let routes: Route[] = [
    {
      key: '/',
      icon: <FaTachometerAlt />,
      label: RouteLanguage.dashboard,
      menu: true,
    },
  ];

  if(user?.roles && ["HOST_MANAGEMENT", "USER_MANAGEMENT"].map(role => user.roles.includes(role)).includes(true)) {

    let children: Route[] = [
      {
        key: '/user-management/user',
        icon: <FaMale />,
        label: RouteLanguage.user,
        menu: true,
      },
    ];

    if(user?.roles && ["HOST_MANAGEMENT"].map(role => user.roles.includes(role)).includes(true))
      children.push(...[
        {
          key: '/user-management/role',
          icon: <FaUserSecret size={12} />,
          label: RouteLanguage.role,
          menu: true,
        },
        {
          key: '/user-management/permission',
          icon: <FaUserShield />,
          label: RouteLanguage.permission,
          menu: true,
        },
      ])

    routes.push( {
      key: '/user-management',
      icon: <FaInfoCircle />,
      label: RouteLanguage.userManagement,
      parent: true,
      menu: true,
      children
    });
  }

  if(user?.roles && ["HOST_MANAGEMENT"].map(role => user.roles.includes(role)).includes(true))
    routes.push( {
      key: '/host-management',
      icon: <FaInfoCircle/>,
      label: RouteLanguage.hostManagement,
      parent: true,
      menu: true,
      children: [
        {
          key: '/host-management/host',
          icon: <FaServer/>,
          label: RouteLanguage.host,
          menu: true,
        },
      ]
    });

  if(user?.roles && ["FILE_MANAGEMENT"].map(role => user.roles.includes(role)).includes(true))
    routes.push( {
      key: '/file-management',
      icon: <FaInfoCircle />,
      label: RouteLanguage.fileManagement,
      parent: true,
      menu: true,
      children: [
        {
          key: '/file-management/file',
          icon: <FaUpload />,
          label: RouteLanguage.file,
          menu: true,
        },
        {
          key: '/file-management/directory',
          icon: <FaSitemap/>,
          label: RouteLanguage.directory,
          menu: true,
        },
      ]
    });

  if(user?.roles && ["BASIC_INFORMATION"].map(role => user.roles.includes(role)).includes(true))
    routes.push( {
      key: '/basic-information',
      icon: <FaInfoCircle />,
      label: RouteLanguage.basicInformation,
      parent: true,
      menu: true,
      children: [
        {
          key: '/basic-information/province',
          icon: <FaMapSigns />,
          label: RouteLanguage.province,
          menu: true,
        },
        {
          key: '/basic-information/city',
          icon: <FaBuilding />,
          label: RouteLanguage.city,
          menu: true,
        },
      ]
    });

  if(user?.roles && ["TICKET_MANAGEMENT"].map(role => user.roles.includes(role)).includes(true))
    routes.push( {
      key: '/ticket-management',
      icon: <FaInfoCircle/>,
      label: RouteLanguage.ticketManagement,
      parent: true,
      menu: true,
      children: [
        {
          key: '/ticket-management/company',
          icon: <FaCubes/>,
          label: RouteLanguage.company,
          menu: true,
        },
        {
          key: '/ticket-management/ticket',
          icon: <FaTicketAlt/>,
          label: RouteLanguage.ticket,
          menu: true,
        },
        {
          key: '/ticket-management/price',
          icon: <FaDollarSign/>,
          label: RouteLanguage.price,
          menu: true,
        },
        {
          key: '/ticket-management/priority',
          icon: <FaLongArrowAltUp/>,
          label: RouteLanguage.priority,
          menu: true,
        },
      ]
    });

  routes.push( {
    key: '/profile',
    icon: <FaUserEdit />,
    label: RouteLanguage.profile,
  });

  routes.push( {
    key: '/email',
    icon: <FaEnvelope />,
    label: RouteLanguage.email,
  });

  routes.push( {
    key: '/mobile',
    icon: <FaMobileAlt />,
    label: RouteLanguage.mobile,
  });

  return routes;
}
